var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{attrs:{"id":"inspire"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('NavigationDrawer')],1),_c('transition',[_c('router-view')],1),_c('AlertMessage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }